import { render, staticRenderFns } from "./forms-section.vue?vue&type=template&id=596806a0&scoped=true"
import script from "./forms-section.vue?vue&type=script&lang=js"
export * from "./forms-section.vue?vue&type=script&lang=js"
import style0 from "./forms-section.vue?vue&type=style&index=0&id=596806a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596806a0",
  null
  
)

export default component.exports